module.exports = __webpack_public_path__ + "img/frame (216).6459e2a4.jpg";